// extracted by mini-css-extract-plugin
export default {"backButton":"SpacePage_backButton__zDPzY"};